module.exports = __webpack_public_path__ + "img/cursor-04.188be0dd.svg";